import React, { useState, useMemo } from 'react';

import { Report } from '~/components';
import { RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelCotaEmpresaVeiculo() {
  const [open, setOpen] = useState(true);
  const [empresa, setEmpresa] = useState([]);

  const cellsCompany = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    return {
      ...params,
      nomeempresaveiculo: empresa.nomeempresaveiculo ?? '',
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.relcotaempresaveiculo')}
      relatorio="relcotaempresaveiculo"
      serialize={(param) => handleSerializeForm(param)}
    >
      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.menu.cadastro.veiculo.empresa')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={cellsCompany}
        getValue={(value) => setEmpresa(value)}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelCotaEmpresaVeiculo;
